import { InformationSources } from './infosource';
import { IPhone } from './phone';

export const AddressTypeIds = { Mailing: 0, Home: 3, Other: 2 };
export enum AddressTypeIdsEnum { Mailing = 0, Home = 3, Other = 2 }

export const AddressTypes = [
    { label: 'Mailing', value: 'MAIL', id: AddressTypeIds.Mailing },
    { label: 'Home', value: 'HOME', id: AddressTypeIds.Home },
    { label: 'Other', value: 'OTHR', id: AddressTypeIds.Other },
];

export interface IHeaderInformation {
    headerTitle: string;
    addressList: IAddress[];
    phoneList: IPhone[];
    faxList: IPhone[];
    emailAddressList: IEmail[];
}

export interface IEmail {
    id?: number;
    email?: string;
    name?: string
}

export interface IAddressBase {
    street1?: string;
    street2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
}

export interface ICoordinates {
    latitude: number;
    longitude: number;
}

export interface IAddress {
    id?: number;
    type?: number;
    street1?: string;
    street2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    source?: InformationSources;

    fullAddress?: string;
    fullMailingAddress?: string;

    county?: string;
    latitude?: number;
    longitude?: number;
    name?: string;

    icon?: string;
    addressType?: string;
    isMailingAddress?: boolean;

    readonly sourceName?: string;
    readonly typeName?: string;

    isHomeAndMailingAddressSame?: boolean;
}

export interface IMemberAddress extends IAddress {
    memberId?: string;
}

export class PendingAddress {
    id?: number;
    memberId: string;
    type?: number;
    street1?: string;
    street2?: string;
    city?: string;
    county?: string;
    state?: string;
    postalCode?: string;
    addressType?: string;
    fullAddress?: string;
    firstObserved?: string;
    firstObservedIn?: string;
    latestObserved?: string;
    latestObservedIn?: string;
    totalObserved?: string;
    actionedOn?: string;
    actionTaken?: string;
    actionedByObjectId?: string;
}

export class MemberAddress implements IMemberAddress {
    id?: number;
    memberId: string;
    type?: number;
    street1?: string;
    street2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    source?: InformationSources;
    fullMailingAddress: string;
    name?: string;
    isMailingAddress?: boolean;
    deletedOn?: Date;
    verifiedOn?: string;
    verifiedByObjectId?: string;

    get sourceName() {
        return InformationSources[this.source];
    }

    get typeName() {
        return AddressTypeIdsEnum[this.type];
    }

    fullAddress?: string;
    county?: string;
    latitude?: number;
    longitude?: number;
    promotionFromId?: number;

    constructor(input: Partial<IMemberAddress>) {
        Object.assign(this, input);
        this.fullAddress = this.formatFullAddress();
    }

    private formatFullAddress?(): string {
        if (this.type == AddressTypeIdsEnum.Mailing && this.isMailingAddress) {
            return 'SAME AS HOME';
        }

        let result = `${this.street1}`;
        const street2 = this.street2 && this.street2.trim();
        if (street2 && street2.length > 0) {
            result += ', ' + street2;
        }

        const city = this.city && this.city.trim();
        if (city && city.length > 0) {
            result += ', ' + city;
        }

        const state = this.state && this.state.trim();
        if (state && state.length > 0) {
            result += ', ' + state;
        }

        const postalCode = this.postalCode && this.postalCode.trim();
        if (postalCode && postalCode.length > 0) {
            if (!state || state.length === 0) {
                result += ',';
            }

            result += ' ' + postalCode;
        }

        return result;
    }

}

export class Address implements IAddress {
    id?: number;
    memberId: string;
    type?: number;
    street1?: string;
    street2?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    fullAddress?: string;
    source?: InformationSources;
    fullMailingAddress: string;
    name?: string;

    constructor(input: any);
    constructor(id: number, memberId: string, type: number, street1: string, street2: string, city?: string, state?: string, postalcode?: string, source?: InformationSources, name?: string);
    constructor(idOrObject: any, memberId?: string, type?: number, street1?: string, street2?: string, city?: string, state?: string, postalcode?: string, source?: InformationSources, name?: string) {

        const pivot = idOrObject || type || street1;
        if (typeof pivot === 'number' || typeof pivot === 'string') {
            this.id = idOrObject as number;
            this.memberId = memberId;
            this.type = type;
            this.street1 = street1;
            this.street2 = street2;
            this.city = city;
            this.state = state;
            this.postalCode = postalcode;
            this.source = source;
            this.name = name;
        }
        else {
            const internal = (idOrObject || {}) as Address;
            this.id = internal.id;
            this.memberId = internal.memberId;
            this.type = internal.type;
            this.street1 = internal.street1;
            this.street2 = internal.street2;
            this.city = internal.city;
            this.state = internal.state;
            this.postalCode = internal.postalCode;
            this.source = internal.source;
            this.name = internal.name;

        }
        this.fullAddress = this.formatFullAddress();

    }

    private formatFullAddress?(): string {

        let result: string;

        result = this.name ? `${this.name?.trim()}, ` : '';
        result += `${this.street1}`;

        const street2 = this.street2 && this.street2.trim();
        if (street2 && street2.length > 0) {
            result += ', ' + street2;
        }

        const city = this.city && this.city.trim();
        if (city && city.length > 0) {
            result += ', ' + city;
        }

        const state = this.state && this.state.trim();
        if (state && state.length > 0) {
            result += ', ' + state;
        }

        const postalCode = this.postalCode && this.postalCode.trim();
        if (postalCode && postalCode.length > 0) {
            if (!state || state.length === 0) {
                result += ',';
            }

            result += ' ' + postalCode;
        }

        return result;
    }
}


// export class MemberAddress {
//    isPrimary: boolean;
//    address: Address;

//    constructor(input: any) {
//        const internal = <MemberAddress>(input || {});
//        this.isPrimary = internal.isPrimary;
//        this.address = new Address(internal.address);
//    }
// }


export const AddressTypeIconMap = {
    [AddressTypeIds.Home]: 'fal fa-house',
    [AddressTypeIds.Mailing]: 'fal fa-envelope',
    [AddressTypeIds.Other]: 'fal fa-address-card'
}

export class AddressDisplay extends MemberAddress {
    typeDisplay: string;
}

export interface GeocodedZipCode {
    zipCode: string;
    latitude: number;
    longitude: number;
}
